import React from "react";
import Sidebar from "./Sidebar";
import * as Yup from "yup";
import { Field, Form, Formik, useFormik } from "formik";
import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";

import { PlusIcon } from "../../../common/imagePath";
import FileInput from "../../../components/FormControls/FileInput";
import { uploadAWS } from "../../../common/AWSHelper";
import axios from "axios";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_EMPLOYEES,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import EditProfileModal from "../../../components/Modal/editPasswordModal";

const EditProfile = (props) => {
  const [formValues, setFormValues] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    PhoneNumber: "",
    SelectImage: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    Comments: "",
    Username: "",
    Language: "",
  });

  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [loading, setLoading] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState(0);
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const paramObject = useParams();
  const navigate = useNavigate();

  const handleManageDataPopup = () => {
    const clearData = {
      ID: 0,
      Name: "",
      Hidefromgrid: false,
      ParentID: 0,
      Color: "",
      Imagename: "",
      CategoryInfopopup: "",
    };
    setFormValues(clearData);
    setImageUrl("");
  };

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
    }), // dropdown menu css
  };

  let languageOptions = [];
  const Language = languages.map((u, i) => {
    languageOptions[i] = { label: u.Name, value: u.Id };
  });

  //Handle Dropdown Data
  const handleDropdownData = (Profiledata) => {
    setLoading(true);
    axios
      .get(`${config.employeesBaseUrl}/employees/employeelanguagesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        setLanguages(res.data.ResponseData);
        console.log("lan: ", res.data.ResponseData);

        if (Profiledata != undefined) {
          // Binding Person data
          let LangList = res.data.ResponseData;

          LangList.map((selectLanguage) => {
            if (selectLanguage.Id === Profiledata.Language) {
              setSelectedLanguages({
                label: selectLanguage.Name,
                value: selectLanguage.Id,
              });
            }
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_EMPLOYEES, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const handleSubmit = (values) => {
    console.log("values: ", values);
    setLoading(true);

    let Profiledata = {
      id: Id || 0,
      firstname: values.FirstName,
      lastname: values.LastName,
      email: values.Email,
      phonenumber: values.PhoneNumber,
      selectimage: ImageUrl,
      address1: values.Address1,
      address2: values.Address2,
      city: values.City,
      state: values.StateProvince,
      username: values.Username,
      zip: values.Zip,
      country: values.Country,
      comments: values.Comments,
      language: selectedLanguages.value,
      loginuserid: Id,
    };

    console.log("Profiledata: Update ", Profiledata);

    axios
      .post(`${config.employeesBaseUrl}/employees/update`, Profiledata, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log("res: ", res.data.ResponseID);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          window.location.reload();
          navigate("/dashboard");
          setLoading(false);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error occured", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    // ?Id=${paramObject.id}
    // Edit Profile Bind
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };
    console.log("log", Id);
    axios
      .get(
        `${config.authenticationBaseUrl}/users/findbyid?Id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        },
        requestOptions
      )
      .then((res) => {
        console.log("get response", res.data.ResponseData);
        const Profiledata = res.data.ResponseData[0];

        setImageUrl(Profiledata.Selectimage);

        const data = {
          FirstName: Profiledata.Firstname,
          LastName: Profiledata.Lastname,
          Email: Profiledata.Email,
          PhoneNumber: Profiledata.Phonenumber,
          SelectImage: "",
          Address1: Profiledata.Address1,
          Address2: Profiledata.Address2,
          City: Profiledata.City,
          StateProvince: Profiledata.State,
          Username: Profiledata.Username,
          Zip: Profiledata.Zip,
          Country: Profiledata.Country,
          Comments: Profiledata.Comments,
          Language: Profiledata.Language,
        };
        setFormValues(data);
        handleDropdownData(Profiledata);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   const id = getIdFromLocalStorage();
  //   if (id > 0) {
  //     setLoading(true); // Edit Profile Bind
  //     const requestOptions = {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ Id: id }),
  //     };

  //     axios
  //       .get(
  //         `${config.authenticationBaseUrl}/users/findbyid`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         },
  //         requestOptions
  //       )
  //       .then((res) => {
  //         console.log("get response", res.data.ResponseData);
  //         const Profiledata = res.data.ResponseData[0];

  //         setImageUrl(Profiledata.Selectimage);

  //         const data = {
  //           FirstName: Profiledata.Firstname,
  //           LastName: Profiledata.Lastname,
  //           Email: Profiledata.Email,
  //           PhoneNumber: Profiledata.Phonenumber,
  //           SelectImage: "",
  //           Address1: Profiledata.Address1,
  //           Address2: Profiledata.Address2,
  //           City: Profiledata.City,
  //           StateProvince: Profiledata.State,
  //           Username: Profiledata.Username,
  //           Zip: Profiledata.Zip,
  //           Country: Profiledata.Country,
  //           Comments: Profiledata.Comments,
  //           Language: Profiledata.Language,
  //         };
  //         setFormValues(data);
  //         handleDropdownData(Profiledata);
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //       });
  //   } else {
  //     handleDropdownData();
  //   }
  // }, []);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title">Profile</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">My Profile</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Edit Profile</h5>

              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#MyProfile"
                data-backdrop="static"
                data-keyboard="false"
                className="btn btn-primary btn-added float-end"
                onClick={() => handleManageDataPopup()}
              >
                Update Password
              </Link>
            </div>
            <Formik
              initialValues={formValues}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.FirstName ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="FirstName"
                              name="FirstName"
                            />
                            <div className="invalid-feedback">
                              {touched.FirstName && errors.FirstName
                                ? errors.FirstName
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.LastName ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="LastName"
                              name="LastName"
                            />
                            <div className="invalid-feedback">
                              {touched.LastName && errors.LastName
                                ? errors.LastName
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            E-Mail <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.EMail ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Email"
                              name="Email"
                            />
                            <div className="invalid-feedback">
                              {touched.EMail && errors.EMail
                                ? errors.EMail
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.PhoneNumber ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="PhoneNumber"
                              name="PhoneNumber"
                            />
                            <div className="invalid-feedback">
                              {touched.PhoneNumber && errors.PhoneNumber
                                ? errors.PhoneNumber
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Select Image
                          </label>
                          <div className="col-md-8">
                            <FileInput
                              id="SelectImage"
                              name="SelectImage"
                              value={selectedImage}
                              accept="image/*"
                              handleChange={_handleFileChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Address 1 <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.Address1 ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Address1"
                              name="Address1"
                            />
                            <div className="invalid-feedback">
                              {touched.Address1 && errors.Address1
                                ? errors.Address1
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className={`${ImageUrl ? "" : selectedImage ? "" : "d-none"
                            } form-group row`}
                        >
                          <label className="col-form-label col-md-4 form-label"></label>
                          <div className="col-md-8">
                            <img
                              src={`${ImageUrl ? ImageUrl : selectedImage}`}
                              alt="Category Image"
                              className="ImagePreviewSize"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6"></div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Address 2 <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.Address2 ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Address2"
                              name="Address2"
                            />
                            <div className="invalid-feedback">
                              {touched.Address2 && errors.Address2
                                ? errors.Address2
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            City <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.City ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="City"
                              name="City"
                            />
                            <div className="invalid-feedback">
                              {touched.City && errors.City ? errors.City : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            State/Province{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.StateProvince ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="StateProvince"
                              name="StateProvince"
                            />
                            <div className="invalid-feedback">
                              {touched.StateProvince && errors.StateProvince
                                ? errors.StateProvince
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Zip <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.Zip ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Zip"
                              name="Zip"
                            />
                            <div className="invalid-feedback">
                              {touched.Zip && errors.Zip ? errors.Zip : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Country <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.Country ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Country"
                              name="Country"
                            />
                            <div className="invalid-feedback">
                              {touched.Country && errors.Country
                                ? errors.Country
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Comments
                          </label>
                          <div className="col-md-8">
                            <Field
                              as="textarea"
                              className={`form-control`}
                              onChange={handleChange}
                              id="Comments"
                              name="Comments"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h5 className="card-title">Employee Login Info</h5>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group row">
                              <label className="col-form-label col-md-4 form-label">
                                Username <span className="text-danger">*</span>
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className={`form-control ${errors.Username ? "is-invalid" : ""
                                    }`}
                                  onChange={handleChange}
                                  id="Username"
                                  name="Username"
                                />
                                <div className="invalid-feedback">
                                  {touched.Username && errors.Username
                                    ? errors.Username
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group row">
                              <label className="col-form-label col-md-4 form-label">
                                Language <span className="text-danger">*</span>
                              </label>
                              <div className="col-md-8">
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  // hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={(event) =>
                                    setSelectedLanguages(event)
                                  }
                                  options={languageOptions}
                                  placeholder=""
                                  styles={selectStyles}
                                  value={
                                    languageOptions.find(
                                      (option) =>
                                        option.value === selectedLanguages.value
                                    ) || ""
                                  }
                                  id="Language"
                                  name="Language"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* button */}
                    <div>
                      <div className="pull-right">
                        <button
                          type="submit"
                          className="btn btn-primary mb-3 me-3"
                        >
                          Save
                        </button>
                        <Link
                          to="/dashboard"
                          className="btn btn-secondary mb-3 "
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <EditProfileModal />
    </>
  );
};

export default EditProfile;
